import axios from 'axios';
const api = axios.create({
    baseURL: process.env?.REACT_APP_API_URL || 'https://app.sigmobi.com',
    responseType: "json",
});



api.interceptors.response.use(
    response => response,
    error => Promise.reject(error)
)

export async function get(url, config = {}) {
    return await api
        .get(url, {
            ...config,
            headers: {
                'Content-Type': 'application/json',
            }
        })
        .then(response => response.data)
}

export async function post(url, data, config = {}) {

    return await api
    .post(url, data, {
        ...config,
        headers: {
           // 'Content-Type': 'multipart/form-data'
        }
    })
    .then(response => response.data)
}



